import Checkout from './checkout';

export default Checkout;
